import { render } from "./TripPacketComponent.vue?vue&type=template&id=35c5e079&scoped=true"
import script from "./TripPacketComponent.vue?vue&type=script&lang=ts"
export * from "./TripPacketComponent.vue?vue&type=script&lang=ts"

import "./TripPacketComponent.vue?vue&type=style&index=0&id=35c5e079&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35c5e079"

export default script